import React from 'react'

const SharePointIcon = ({ size = 18, style }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    role='img'
    aria-label='SharePoint'
    style={{ display: 'block', flexShrink: 0, ...style }}
  >
    <circle cx='9' cy='7.6' r='6' fill='#036C70' />
    <circle cx='15.4' cy='13.2' r='6.6' fill='#1A9BA1' />
    <circle cx='10.6' cy='18' r='4.6' fill='#37C6D0' />
  </svg>
)

export default SharePointIcon
